import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TuiActiveZoneModule, TuiPressedModule, TuiHoveredModule } from '@taiga-ui/cdk';
import {
  TuiHostedDropdownModule,
  TuiPrimitiveTextfieldModule,
  TuiTextfieldControllerModule,
  TuiHintModule
} from '@taiga-ui/core';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { AitColorSelectorModule } from '../color-selector/color-selector.module';
import { AitColorOptionsControllerModule } from '../directives/color-options-controller/color-options-controller.module';
import { AitInputColorComponent } from './input-color.component';
import { MaskitoModule } from '@maskito/angular';

@NgModule({
  imports: [
    CommonModule,
    MaskitoModule,
    TuiPrimitiveTextfieldModule,
    TuiTextfieldControllerModule,
    TuiHintModule,
    PolymorpheusModule,
    TuiHostedDropdownModule,
    AitColorSelectorModule,
    TuiActiveZoneModule,
    AitColorOptionsControllerModule,
    TuiPressedModule,
    TuiHoveredModule
  ],
  declarations: [AitInputColorComponent],
  exports: [AitInputColorComponent]
})
export class AitInputColorModule {}
